import React from 'react';

import ConfiguratorPageStep1 from 'components/ConfiguratorPageStep1';

const ConfiguratorStep1 = () => (
  <ConfiguratorPageStep1 />
);

export default ConfiguratorStep1;
